import { useCallback, useLayoutEffect, useRef, useState } from 'react';

import { useInsideSurface } from '@/components/ui/surface';

/**
 * LIGGER TILSTANDEN ALLEREDE PÅ ET ARK? (Glass 2, DESIGN.md §16.3 og §16.5 punkt 8.)
 *
 * Konteksten svarer for `Card` og dialogen. En `Table` er selv et ark, men sier ikke fra til
 * cellene sine, så den tomme tilstanden i en tabell ville fått et ark inni arket. Derfor spør den
 * også DOM-en, i `useLayoutEffect`, altså før første maling, så ingenting blinker.
 *
 * Svaret brukes av `EmptyState` og `ErrorState`: på et ark står de rett på det; på siden får de
 * sitt eget, så teksten aldri står rett på bakgrunnen.
 */
export function useOnASheet(): { onSheet: boolean; ref: (node: HTMLElement | null) => void } {
  const context = useInsideSurface();
  const node = useRef<HTMLElement | null>(null);
  const [inDom, setInDom] = useState(false);
  useLayoutEffect(() => {
    const parent = node.current?.parentElement ?? null;
    setInDom(parent?.closest('.glass-content, .glass-popover, [role="dialog"], table') != null);
  }, []);
  const ref = useCallback((element: HTMLElement | null) => {
    node.current = element;
  }, []);
  return { onSheet: context || inDom, ref };
}
